module.exports = angular.module('cartographer.common.config', [])

module.exports.config $DI () ->
  # Set up global ieVersion variable:
  unless window.ieVersion
    if !!window.MSInputMethodContext && !!document.documentMode
      window.ieVersion = 11
    else
      angular.element(
        """
        <div class="ng-hide">
          <!--[if IE  6]><script>window.ieVersion = 6;</script><![endif]-->
          <!--[if IE  7]><script>window.ieVersion = 7;</script><![endif]-->
          <!--[if IE  8]><script>window.ieVersion = 8;</script><![endif]-->
          <!--[if IE  9]><script>window.ieVersion = 9;</script><![endif]-->
        </div>
        """
      ).appendTo(document.body).remove()

  return

module.exports.factory 'crtConfig', $DI ($window) ->
  iso8601ParseFormats = [
    'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
    'YYYY-MM-DD[T]HH:mm:ss[Z]'
  ]

  iso8601DisplayFormat =
    'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]'

  local =
    /localhost/.test($window.location.hostname) ||
    /\.local$/.test($window.location.hostname) ||
    /^192\./.test($window.location.hostname)

  beta =
    /beta\.cartographer\.io$/.test($window.location.hostname)

  next =
    /next\.cartographer\.io$/.test($window.location.hostname)

  baseDomain = if local
    window.location.host
  else if beta
    "beta.cartographer.io"
  else if next
    "next.cartographer.io"
  else
    "cartographer.io"

  storagePrefix = if beta
    'crtBeta'
  else if next
    'crtNext'
  else
    'crt'

  apiRootUrl =
    if local
      "/api"
    else if beta
      "https://api.beta.cartographer.io"
    else if next
      "https://api.next.cartographer.io"
    else
      "https://api.cartographer.io"

  cookieDefaults =
    if local
      expires: 7
      path: '/'
    else
      expires: 7
      path: '/'
      domain: baseDomain
      secure: true

  fathom = !local && !beta && !next

  glBaseUrl = if local
    "http://localhost:3000/embed/map"
  else if beta
    "https://app.beta.cartographer.io/embed/map"
  else if next
    "https://app.next.cartographer.io/embed/map"
  else
    "https://app.cartographer.io/embed/map"

  formBaseUrl = if local
    "http://localhost:3000/embed/survey"
  else if beta
    "https://app.beta.cartographer.io/embed/survey"
  else if next
    "https://app.next.cartographer.io/embed/survey"
  else
    "https://app.cartographer.io/embed/survey"

  if $window.ieVersion
    angular.element("html").addClass("ie ie#{$window.ieVersion}")

  return {
    beta
    next
    local
    baseDomain: baseDomain
    app:
      name: process.env.APP_NAME ? "UNDEFINED"
      version: require("package.version")
    api:
      rootUrl: apiRootUrl
    company:
      companyUrl:          "https://#{baseDomain}"
      websiteTermsUrl:     "https://#{baseDomain}/legal/website-terms"
      platformTermsUrl:    "https://#{baseDomain}/legal/platform-terms"
      privacyPolicyUrl:    "https://#{baseDomain}/legal/privacy-policy"
      cookiePolicyUrl:     "https://#{baseDomain}/legal/cookie-policy"
      acknowledgementsUrl: "https://#{baseDomain}/acknowledgements"
      helpUrl:             "https://help.cartographer.io"
      supportContactUrl:   "https://help.cartographer.io/contact"
      rot13ContactPhone:   "575 854 00884"
      rot13ContactEmail:   "uryyb@pnegbtencure.vb"
    datetime:
      iso8601ParseFormats: iso8601ParseFormats
      iso8601DisplayFormat: iso8601DisplayFormat
      dateFormats: [
        'DD/MM'
        'DD/MM/YY'
        'DD/MM/YYYY'
        'YYYY-MM-DD'
      ]
      timeFormats: [
        'HH:mm'
      ]
      datetimeFormats: [
        'DD/MM HH:mm'
        'DD/MM/YY HH:mm'
        'DD/MM/YYYY HH:mm'
        'YYYY-MM-DD HH:mm'
      ].concat(iso8601ParseFormats)
      displayFormat: 'DD/MM/YYYY HH:mm'
    form:
      disableMapFields: $window.ieVersion && $window.ieVersion <= 9
      slowValidationDelay: 250 # ms
      fastValidationDelay: 50 # ms
      initialValidationDelay: 500 # ms
    fathom: fathom
    http:
      prettyPrint: true
    ieVersion: $window.ieVersion
    list:
      reloadDelay: 250
      pageSize: 25
      paginationSize: 2 # N pages to the left AND right of the current
    location:
      ngrPrecision: 10
      gpsPrecision: 6
    log:
      mode: if $window.ieVersion then 'json' else 'normal'
      level: 4 # 0 = none, 1 = error, 2 = warn, 3 = info, 4 = debug
    map:
      defaultZoom: 11 # maps start at this zoom (or the workspaceal default)
      defaultTiles: 'terrain'
      defaultSelectionRadius: 50/1000 # km
      defaultMapFieldAutoZoom: 14 # find me / find marker zoom in to this level
      defaultSiteFieldAutoZoom: 10
      doubleClickDelay: 100 # ms
      mapbox:
        accessToken: 'pk.eyJ1IjoiY2FydG9ncmFwaGVyaW8iLCJhIjoiY2s5anQzZHU4MDBpeTNmbHJ5NmJtNDQxNyJ9.5yFyTxkdVe1TcilSZdL08Q'
        tiles:
          terrain   : 'cartographerio/ck9cnl9660q7i1io7ozxeu395'
          satellite : 'cartographerio/ck9cnm9d40ial1it6unjb4qm0'
    storage:
      prefix: storagePrefix
      cookie:
        defaults: cookieDefaults
    toast:
      hideDelay: 2000
    attachment:
      defaultMaxFiles: 4
      maxSizeMegabytes: 20
    workspace:
      defaultLogoUrl: '/static/images/workspaces/demo.png'
    preview:
      gl:
        enable: true
        baseUrl: glBaseUrl
      form:
        enable: true
        baseUrl: formBaseUrl
  }
